import { useState, useEffect } from "react"
import { useParams, Link, useNavigate, useLocation } from "react-router-dom"
import { ArrowLeft, FileText, Download } from "lucide-react"
import authService from '../../../Services/authService';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { height, width } from "@fortawesome/free-brands-svg-icons/fa42Group";



function OrderDetails() {
  const { orderId } = useParams()
  const location = useLocation();
  let invoiceid = orderId || location.pathname.split('/')[2]; // Use orderId from params first
  const navigate = useNavigate()
  const [order, setOrder] = useState([])
  const [loading, setLoading] = useState(true)
  const [activeTab, setActiveTab] = useState("")
  const token = authService.getCurrentUsertoken();
  //alert(invoiceid);
  const visitTypeIds = order?.visit_type?.map(v => v.visit_type_id) || [];
  const hasAtHome = visitTypeIds.includes(1);
  const hasAtLab = visitTypeIds.includes(2);

  // Set default tab when orderDetals updates

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setLoading(true);
    loadOrderDetails();
  }, []);

  const loadOrderDetails = () => {

    const url = new URL(authService.getApiUrl() + 'orderdetails/' + invoiceid);
    fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`, // Add Authorization header with Bearer token
      },
    })
      .then((res) => {
        // if (res.status === 401) {
        //   authService.clientlogout();
        //   window.location.href = "/login";
        // } else {
        return res.json();
        // }
      })
      .then((result) => {
        //const data = result.data;
        // if (Array.isArray(result.data) && result.data.length > 0) {
        setLoading(false);
        setOrder(result.data); // Store the first object

        //}
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  useEffect(() => {
    if (hasAtHome) {
      setActiveTab("home"); // Prioritize "At Home"
    } else if (hasAtLab) {
      setActiveTab("lab"); // If no "At Home", set "At Lab"
    }
  }, [hasAtHome, hasAtLab]);



  if (loading) {
    return (
      <div className="min-h-screen bg-[#F5F5F7] flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#951C25]"></div>
      </div>
    )
  }

  if (!order) {
    return (
      <div className="min-h-screen bg-[#F5F5F7] flex items-center justify-center">
        <div className="text-center p-8">
          <h1 className="text-2xl font-semibold text-[#4A4A4A] mb-4">Order not found</h1>
          <p className="text-[#4A4A4A]/70 mb-6">The order you're looking for doesn't exist or has been removed.</p>
          <Link to="#" onClick={() => window.history.back()} className="inline-flex items-center text-[#951C25] hover:underline">
            <ArrowLeft size={16} className="mr-2" />
            Back to My Orders
          </Link>
        </div>
      </div>
    )
  }

  const currentStatus = 0;

  const statusSteps = [
    "Order Placed",
    "Assigned To Delivery Agent",
    "On The Way",
    "Sample Collected",
    "Order Completed",
  ]

  const lab_order_tracking = [
    "Order Placed",
    "Order Completed",
  ];

  const handleDownloadReportAtHome = async () => {
    if (!order || !order.athome) {
      console.error("No lab reports available");
      return;
    }

    order.athome.forEach(report => {
      window.open(authService.getApiDomainUrl() + report.document_name, '_blank');
    });
  };

  const handleDownloadReportAtLab = async () => {
    if (!order || !order.atlab) {
      console.error("No lab reports available");
      return;
    }

    order.atlab.forEach(report => {
      window.open(authService.getApiDomainUrl() + report.document_name, '_blank');
    });
  };

  const handleDownloadInvoice = async () => {
    const input = document.getElementById('styled-invoice');
    if (!input) {
      console.error("Invoice element not found");
      return;
    }

    try {
      const canvas = await html2canvas(input, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#fff'
      });

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const width = pdf.internal.pageSize.getWidth();
      const height = (canvas.height * width) / canvas.width;

      pdf.addImage(imgData, 'PNG', 0, 0, width, height);
      pdf.save(`Invoice_${order.invoice_number || 'Order'}.pdf`);
    } catch (err) {
      console.error("PDF generation failed", err);
    }
  };


  return (
    <div className="min-h-screen bg-[#F5F5F7]">
      {/* Order Details Header */}
      <div className="bg-white border-b border-[#E0E0E0]">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center">
          <button onClick={() => window.history.back()} className="mr-4">
            <ArrowLeft size={20} className="text-[#4A4A4A]" />
          </button>
          <h1 className="text-lg font-medium text-[#4A4A4A]">ORDER DETAILS</h1>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-6">
        {/* Hospital Info */}
        {/* <div className="bg-white rounded-lg border border-[#E0E0E0] p-4 mb-4">
          <h2 className="text-lg font-medium text-[#4A4A4A]">{order.hospitalName}</h2>
          <p className="text-sm text-[#4A4A4A]/70">{order.hospitalLocation}</p>
        </div> */}

        {/* Service Type Tabs */}
        {(order.order_status_id !== 6 && order.lab_order_status_id !== 6) && (
          <div className="bg-white rounded-lg border border-[#E0E0E0] mb-4">

            <div className="flex border-b border-[#E0E0E0]">
              {hasAtHome && (
                <button
                  className={`flex-1 py-3 text-center ${activeTab === "home"
                    ? "text-[#951C25] border-b-2 border-[#a29193]"
                    : "text-[#4A4A4A]"
                    }`}
                  onClick={() => setActiveTab("home")}
                >
                  At Home
                </button>
              )}
              {hasAtLab && (
                <button
                  className={`flex-1 py-3 text-center ${activeTab === "lab"
                    ? "text-[#951C25] border-b-2 border-[#a29193]"
                    : "text-[#4A4A4A]"
                    }`}
                  onClick={() => setActiveTab("lab")}
                >
                  At Lab
                </button>
              )}
            </div>




            {/* At Lab Content - Only shown when lab tab is active */}
            {activeTab === "lab" && (
              <div className="bg-white  p-4 mb-4">
                {/* Order Status Tracker for Lab */}
                <h3 className="text-base font-medium text-[#4A4A4A] mb-6 text-center">Order Status</h3>

                <div className="relative mb-6">
                  {/* Progress Line */}
                  <div className="absolute top-2 left-0 right-0 h-0.5 bg-[#E0E0E0]"
                    style={{ width: '75%' }}
                  ></div>

                  {/* Progress Fill */}
                  <div
                    className="absolute top-2 left-0 h-0.5 bg-[#951C25]"
                    style={{ width: '75%' }}
                  ></div>

                  {/* Status Steps for Lab Visit */}
                  <div className="flex justify-between relative">
                    {lab_order_tracking.map(
                      (step, index) => (
                        <div key={index} className="flex flex-col items-center" style={{ width: "50%" }}>
                          <div
                            className={`w-4 h-4 rounded-full ${index < order.lab_order_status_id ? "bg-[#951C25]" : "bg-[#E0E0E0]"
                              } mb-3 z-10`}
                          ></div>
                          <span className="text-[10px] md:text-xs text-[#4A4A4A] text-center leading-tight">{step}</span>
                        </div>
                      ),
                    )}
                  </div>
                </div>

                {/* Download Buttons */}
                <div className="flex gap-3 justify-center">
                  <button
                    className="flex items-center px-4 py-2 border border-[#951C25] text-[#951C25] rounded-md text-sm hover:bg-[#951C25]/5"
                    onClick={handleDownloadInvoice}
                  >
                    <FileText size={16} className="mr-2" />
                    Download Invoice
                  </button>
                  <button className="flex items-center px-4 py-2 border border-[#951C25] text-[#951C25] rounded-md text-sm hover:bg-[#951C25]/5" onClick={handleDownloadReportAtLab}>
                    <Download size={16} className="mr-2" />
                    Download Report
                  </button>
                </div>
              </div>
            )}

            {activeTab === "home" && (
              <div className="bg-white p-4 mb-4">
                <h3 className="text-base font-medium text-[#4A4A4A] mb-6 text-center">Order Status</h3>

                <div className="relative mb-6">
                  {/* Progress Line */}
                  <div className="absolute top-2 left-0 right-0 h-0.5 bg-[#E0E0E0]"
                    style={{ width: '92%' }}
                  ></div>

                  {/* Progress Fill */}
                  <div
                    className="absolute top-2 left-0 h-0.5 bg-[#951C25]"
                    style={{ width: '92%' }}
                  ></div>

                  {/* Status Steps */}
                  <div className="flex justify-between relative">
                    {statusSteps.map((step, index) => (

                      <div key={index} className="flex flex-col items-center" style={{ width: '20%' }}>
                        <div
                          className={`w-4 h-4 rounded-full ${index < order.order_status_id ? "bg-[#951C25]" : "bg-[#E0E0E0]"
                            } mb-3 z-10`}
                        ></div>
                        <span className="text-[10px] md:text-xs text-[#4A4A4A] text-center leading-tight">{step}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Download Buttons */}
                <div className="flex gap-3 justify-center">
                  <button
                    className="flex items-center px-4 py-2 border border-[#951C25] text-[#951C25] rounded-md text-sm hover:bg-[#951C25]/5"
                    onClick={handleDownloadInvoice}
                  >
                    <FileText size={16} className="mr-2" />
                    Download Invoice
                  </button>
                  <button className="flex items-center px-4 py-2 border border-[#951C25] text-[#951C25] rounded-md text-sm hover:bg-[#951C25]/5" onClick={handleDownloadReportAtHome}>
                    <Download size={16} className="mr-2" />
                    Download Report
                  </button>
                </div>
              </div>
            )}

          </div>
        )}

        {/* Your Order */}
        <div className="bg-white rounded-lg border border-[#E0E0E0] p-4 mb-4">
          <h3 className="text-base font-medium text-[#4A4A4A] mb-4">Your Order</h3>

          {order.orders_items.map((item, index) => (
            <div key={index} className="flex items-center justify-between mb-4 border-b border-[#E0E0E0] pb-4">
              <div className="flex items-center">
                <div className="w-8 h-8 bg-[#F5F5F7] rounded-md flex items-center justify-center mr-3 text-[#951C25]">
                  <span className="text-sm">1</span>
                </div>
                <span className="text-base text-[#4A4A4A]">× {item.test_name}</span>
              </div>
              <div className="flex items-center">
                {/* <span className="text-base font-medium text-[#4A4A4A]"></span> */}
                <span className="ml-4 text-base font-medium text-[#4A4A4A]">₹{Number(item.price).toFixed(2)}</span>
              </div>
            </div>
          ))}

          <div className="space-y-3">
            <div className="flex justify-between">
              <span className="text-base text-[#4A4A4A]">Item total</span>
              <span className="text-base font-medium text-[#4A4A4A]">₹{Number(order.total_price).toFixed(2)}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-base text-[#4A4A4A]">Taxes</span>
              <span className="text-base text-[#4A4A4A]">₹{Number(order.tax_amount).toFixed(2)}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-base text-[#4A4A4A]">Discount</span>
              <span className="text-base text-[#4A4A4A]">{Number(order.discount_price) > 0 ? `- ₹${Number(order.discount_price).toFixed(2)}` : '-'}</span>
            </div>

            {/* <div className="flex justify-between">
              <span className="text-base text-[#4A4A4A]">Delivery Charges</span>
              <span className="text-base text-[#4A4A4A]">
                {order.deliveryCharges > 0 ? `₹${order.deliveryCharges.toFixed(2)}` : "FREE"}
              </span>
            </div>
            */}

            <div className="flex justify-between pt-3 border-t border-[#E0E0E0]">
              <span className="text-base font-medium text-[#4A4A4A]">Grand total</span>
              <span className="text-lg font-semibold text-[#4A4A4A]"> ₹{parseFloat(order.final_price).toFixed(2)}</span>
            </div>
          </div>
        </div>

        {/* Order Details */}
        <div className="bg-white rounded-lg border border-[#E0E0E0] p-4">
          <h3 className="text-base font-medium text-[#4A4A4A] mb-4">Order Details</h3>

          <div className="space-y-4">
            {order.transaction_id != null && (
              <div>
                <p className="text-sm text-[#4A4A4A]/70">Transaction ID</p>
                <p className="text-sm text-[#4A4A4A]">{order.transaction_id}</p>
              </div>
            )}
            {(order.order_status_id === 6 || order.lab_order_status_id === 6) && (
              <div>
                <p className="text-sm text-[#4A4A4A]/70">Order Status</p>
                <p className="text-sm text-red-600">Payment success but order not placed.</p>
              </div>
            )}
            {(order.order_status_id === 7 || order.lab_order_status_id === 7) && (
              <div>
                <p className="text-sm text-[#4A4A4A]/70">Order Status</p>
                <p className="text-sm text-green-600">Refund Completed.</p>
              </div>
            )}
            <div>
              <p className="text-sm text-[#4A4A4A]/70">Invoice Number</p>
              <p className="text-sm text-[#4A4A4A]">{order.invoice_number}</p>
            </div>

            {/* <div>
              <p className="text-sm text-[#4A4A4A]/70">Payment</p>
              <p className="text-sm text-[#4A4A4A]">{order.payment_mode}</p>
            </div> */}

            <div>
              <p className="text-sm text-[#4A4A4A]/70">Date</p>
              <p className="text-sm text-[#4A4A4A]">{order?.orderdate
                ? new Date(order.orderdate).toLocaleString('en-IN', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                  hour12: true,
                  timeZone: 'Asia/Kolkata' // Adjusts to IST
                })
                : 'N/A'}</p>
            </div>

            <div>
              <p className="text-sm text-[#4A4A4A]/70">User Name</p>
              <p className="text-sm text-[#4A4A4A]">{order?.user_name}</p>
            </div>

            <div>
              <p className="text-sm text-[#4A4A4A]/70">Phone Number</p>
              <p className="text-sm text-[#4A4A4A]">{order?.address?.phone_number}</p>
            </div>

            <div>
              <p className="text-sm text-[#4A4A4A]/70">Address</p>
              <p className="text-sm text-[#4A4A4A]">{order?.address?.building_name}, {order?.address?.landmark}, {order?.address?.area}, {order?.address?.pincode}</p>
            </div>

          </div>
        </div>
      </div>

      <div
        id="styled-invoice"
        style={{
          position: 'absolute',
          left: '-9999px',
          top: 0,
          width: '800px',
          backgroundColor: '#ffffff',
          padding: '20px',
          fontSize: '12px',
          fontFamily: 'Arial, sans-serif',
          color: '#000',
        }}
      >
        {/* Invoice Header */}
        <div style={{ textAlign: 'center', marginBottom: '12px' }}>
          {/* Logo - optional */}

          <img
            src="/images/pranaam-365-logo.png"
            alt="Hospital Logo"
            style={{ height: '50px', marginBottom: '4px' }}
          />


          {/* Tax Invoice Title */}
          <h2 style={{ fontWeight: 'bold', fontSize: '16px', margin: 0, color: '#000', marginBottom: '25px' }}>Tax Invoice</h2>
        </div>






        {/* Invoice Meta Info */}
        <table style={{ width: '100%', marginBottom: '12px', color: '#000' }}>
          <tbody>
            <tr>
              <td><strong>Invoice No:</strong></td>
              <td>{order.invoice_number}</td>
            </tr>
            <tr>
              <td><strong>Invoice Date:</strong></td>
              <td>{new Date(order.orderdate).toLocaleDateString('en-IN')}</td>
            </tr>
            <tr>
              <td><strong>Customer Name:</strong></td>
              <td>{order.user_name}</td>
            </tr>
            <tr>
              <td><strong>Delivery Address:</strong></td>
              <td>
                {`${order.address?.building_name || ''}, ${order.address?.area || ''}, ${order.address?.pincode || ''}`}
              </td>
            </tr>

            {/* <tr>
              <td><strong>Hospital Name:</strong></td>
              <td>{order.orders_info?.organization_name}</td>
            </tr>
            <tr>
              <td><strong>Hospital Address:</strong></td>
              <td>{order.orders_info?.area_name}, {order.orders_info?.landmark}, {order.orders_info?.city_name}</td>
            </tr> */}

          </tbody>
        </table>


        {/* Order Summary Table */}
        <h3 style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '8px', color: '#000' }}>Order Summary</h3>
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            marginBottom: '12px',
            color: '#000',
          }}
        >
          <thead>
            <tr>
              <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'left', fontWeight: 'bold' }}>#</th>
              <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'left', fontWeight: 'bold' }}>Tests</th>
              <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'right', fontWeight: 'bold' }}>Price</th>
            </tr>
          </thead>
          <tbody>
            {order.orders_items.map((item, index) => (
              <tr key={index}>
                <td style={{ border: '1px solid #000', padding: '6px' }}>{index + 1}</td>
                <td style={{ border: '1px solid #000', padding: '6px' }}>
                  {item.quantity} × {item.test_name}
                </td>
                <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'right' }}>
                  ₹{Number(item.price).toFixed(2)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Totals */}
        <table style={{ width: '100%', color: '#000' }}>
          <tbody>
            <tr>
              <td style={{ fontWeight: 'bold', paddingTop: '4px' }}>Total:</td>
              <td style={{ textAlign: 'right', paddingTop: '4px' }}>₹{Number(order.total_price).toFixed(2)}</td>
            </tr>
            <tr>
              <td style={{ fontWeight: 'bold', paddingTop: '4px' }}>GST:</td>
              <td style={{ textAlign: 'right', paddingTop: '4px' }}>₹{Number(order.tax_amount).toFixed(2)}</td>
            </tr>
            <tr>
              <td style={{ fontWeight: 'bold', paddingTop: '4px' }}>Discount:</td>
              <td style={{ textAlign: 'right', paddingTop: '4px' }}>
                {Number(order.discount_price) > 0 ? `- ₹${Number(order.discount_price).toFixed(2)}` : '-'}

              </td>
            </tr>
            <tr>
              <td style={{ fontWeight: 'bold', fontSize: '14px', paddingTop: '10px' }}>Grand Total:</td>
              <td style={{ fontWeight: 'bold', fontSize: '14px', textAlign: 'right', paddingTop: '10px' }}>
                ₹{Number(order.final_price).toFixed(2)}
              </td>
            </tr>
          </tbody>
        </table>

        {/* Footer */}
        {/* <div style={{ marginTop: '20px', fontSize: '10px', color: '#000' }}>
          <p>For {order.orders_info?.organization_name || 'The Organization'}</p>
          <p style={{ marginTop: '4px' }}>Authorised Signatory</p>

          
        </div>
        {order.authorized_signature?.image && (
          <div style={{ marginTop: '20px', fontSize: '10px', color: '#000', width: '200px', height: '100px' }}>
            <img
              src="https://api.Pranaam365.com/uploads/authorized_signature/1749473551.png"
              alt="Signature"
              crossOrigin="anonymous"
              style={{ marginTop: '4px', width: '100%' }}
            />
           
          </div>
        )} */}
      </div>



    </div>
  )
}

export default OrderDetails

